import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck, FiDownload, FiMail, FiGift } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const SuccessModal = ({ isOpen, onClose }) => {
  const [emailSent, setEmailSent] = useState(false);

  const handleSendToEmail = () => {
    // Simulate sending to email
    setEmailSent(true);
    setTimeout(() => setEmailSent(false), 3000);
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="bg-white rounded-3xl p-8 max-w-md w-full text-center relative"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.5, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full"
          >
            ×
          </button>

          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiCheck} className="w-10 h-10 text-green-600" />
          </div>

          <h3 className="text-2xl font-bold text-gray-800 mb-4">
            Payment Successful! 🎉
          </h3>

          <div className="bg-gradient-to-r from-purple-50 to-orange-50 p-6 rounded-2xl mb-6">
            <p className="text-gray-700 mb-4">
              Thank you for your purchase! Your Diwali Success Package is now available.
            </p>
            <div className="space-y-3 text-left">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiDownload} className="w-5 h-5 text-purple-600" />
                <span className="text-sm">24 Ways eBook (Instant Download)</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-orange-500" />
                <span className="text-sm">Access sent to your email</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiGift} className="w-5 h-5 text-green-500" />
                <span className="text-sm">All 5 Bonuses Included</span>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={handleSendToEmail}
              className="w-full bg-purple-600 text-white py-3 rounded-xl font-semibold hover:bg-purple-700 transition-colors"
            >
              📧 Send Access to Email
            </button>
            <button
              onClick={onClose}
              className="w-full bg-gray-100 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
            >
              Close
            </button>
          </div>

          {emailSent && (
            <div className="mt-4 text-green-600 text-sm">
              ✓ Access details sent to your email!
            </div>
          )}

          <p className="text-xs text-gray-500 mt-4">
            Check your spam folder if you don't see the email within 5 minutes.
          </p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default SuccessModal;